"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Recaptcha = void 0;
const react_1 = __importStar(require("react"));
require("./recaptcha.css");
;
/**
 * Main component.
 * @name Recaptcha
 * @param {RecaptchaProps}
 * @returns {<Recaptcha />}
*/
const Recaptcha = ({ sitekey, handlerRecaptchaResponse }) => {
    const [recaptchaResponse, setRecaptchaResponse] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        //Adding recaptcha
        const script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/api.js";
        window.onsubmit = (callback) => setRecaptchaResponse(callback);
        document.body.appendChild(script);
    }, []);
    (0, react_1.useEffect)(() => {
        handlerRecaptchaResponse(recaptchaResponse);
    }, [handlerRecaptchaResponse, recaptchaResponse]);
    return (react_1.default.createElement("div", { "data-testid": "recaptcha-element", className: "recaptcha-container" },
        react_1.default.createElement("div", { className: "g-recaptcha", "data-sitekey": sitekey, "data-callback": "onsubmit", "data-expired-callback": "onsubmit" })));
};
exports.Recaptcha = Recaptcha;
//# sourceMappingURL=recaptcha.js.map